import AddIcon from '@mui/icons-material/Add';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import { useTranslation } from 'react-i18next';
import { Navigate, Route, useParams } from 'react-router-dom';
import { ProtectedRoute, TrcApp } from 'thermia-react-container';
import { setConfig } from './config';
import AdminRegistrations from './pages/admin/registrations/adminRegistrations';
import CompletedRegistrations from './pages/completedRegistrations/completedRegistrations';

import { RegistrationsProvider } from './context/registrationProvider';
import Registration from './pages/registration/registration';
import Registrations from './pages/registrations/registrations';
import UnregisteredDevices from './pages/unregisteredDevices/unregisteredDevices';
import AdminPartners from "./pages/admin/partners/adminPartners";
import Admin from "./pages/admin/admin";

const App = () => {
  const { t } = useTranslation('registrations');

  document.title = t('registrations.general.siteTitle');

  const { id } = useParams();
  const ProtectedAdmin = ProtectedRoute(Admin, 'rc_adm');
  const ProtectedRegistrations = ProtectedRoute(AdminRegistrations, 'rc_adm');
  const ProtectedPartners = ProtectedRoute(AdminPartners, 'rc_adm');

  return (
    <TrcApp
      configPath="/config/config.json"
      setConfig={setConfig}
      title={t('registrations.general.appTitle')}
      logoLink={'https://partnerlogin.thermia.se/sv/home.html'}
      logoText={'PARTNERLOGIN'}
      requiredPermissions={['rc_rd']}
      contentMaxWidth={'xl'}
      routes={
        <Route>
          <Route path="/" element={<Navigate to={`/registrations`} replace />} />
          <Route path="/new-registration/:tabPage?" element={<Registration key={'new'} />} />
          <Route path="/registrations/:id/:tabPage?" element={<Registration key={`${id}`} />} />
          <Route path="/completed-registrations/:id/:tabPage" element={<Registration key={`${id}`} />} />
          <Route path="/registrations" element={<Registrations />} />
          <Route path="/completed-registrations" element={<CompletedRegistrations />} />
          <Route path="/unregistered-devices" element={<UnregisteredDevices />} />
          <Route path="/admin/" element={<ProtectedAdmin />} />
          <Route path="/admin/registrations/:search?" element={<ProtectedRegistrations />} />
          <Route path="/admin/partners/:search?" element={<ProtectedPartners />} />
        </Route>
      }
      applicationProvider={RegistrationsProvider}
      tabs={[
        {
          icon: AddIcon,
          label: t('registrations.general.addNewRegistration'),
          path: 'new-registration'
        },
        {
          icon: FormatListBulletedIcon,
          label: t('registrations.general.ongoingRegistrations'),
          path: 'registrations'
        },
        {
          icon: PlaylistAddCheckIcon,
          label: t('registrations.general.completedRegistrations'),
          path: 'completed-registrations',
          requiredPermission: 'rc_rh'
        },
        {
          icon: ErrorOutlineIcon,
          label: t('registrations.general.unregisteredDevices'),
          path: 'unregistered-devices'
        },
        {
          icon: AdminPanelSettingsIcon,
          label: t('registrations.admin.admin'),
          path: 'admin',
          requiredPermission: 'rc_adm'
        }
      ]}
    />
  );
};

export default App;
